export default __webpack_public_path__ + "static/media/analytics-blue-icon.7f0b4b0d.svg";